import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=15b6232a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b6232a')) {
      api.createRecord('15b6232a', component.options)
    } else {
      api.reload('15b6232a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=15b6232a&", function () {
      api.rerender('15b6232a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JQ25hwKUE9fQ/JS/IncreaseNumber.vue"
export default component.exports